<mat-toolbar>
  <!--<button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon">
    <mat-icon>menu</mat-icon>
  </button>-->
  <span>Customer Tools</span>
  <span class="toolbar-spacer"></span>
  <!--<button mat-fab extended (click)="openSubscriptionBuilder()">
    <mat-icon>add</mat-icon>
    Create Subscription
  </button>
  <button mat-fab extended (click)="openCustomerCreditDialog()">
    <mat-icon>add</mat-icon>
    Add Credit
  </button>-->
  <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Customer Actions">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="openInvoiceItemDialog()">
      <mat-icon>request_quote</mat-icon>
      <span>Add One-time Fee</span>
    </button>
    <button mat-menu-item (click)="openCustomerCreditDialog()">
      <mat-icon>paid</mat-icon>
      <span>Add Credit</span>
    </button>
    <button mat-menu-item (click)="openSubscriptionBuilder()">
      <mat-icon>sell</mat-icon>
      <span>Add Subscription</span>
    </button>
  </mat-menu>
</mat-toolbar>
<div class="customer-holder">
  <div class="form-holder">
    <app-dynamic-form [model]="'Customer'" [hideRelationships]="true" (relationshipOutput)="handleRelationshipOutput($event)" (itemOutput)="handleItemOutput($event)"></app-dynamic-form>
  </div>

  @if (customerStripeId && customer){
  <div class="stripe-subs-holder">
    <app-stripe-customer-subscriptions [customer]="customer" (cardActionClick)="handleCardClick($event)"></app-stripe-customer-subscriptions>
  </div>
  }

</div>